module.exports = __webpack_public_path__ + "static/media/pic-das-steck-drin.40cd1d7c.jpg";